import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/upload@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-e64ba5e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "laiiva-color-sketch-container" }
const _hoisted_2 = {
  key: 0,
  class: "recently"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "最近使用颜色", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "recently"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "最近使用颜色", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "color-panel" }
const _hoisted_10 = { class: "gradient-box" }
const _hoisted_11 = ["onClick", "onMousedown"]
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "degree-sign" }, "°", -1))
const _hoisted_14 = { class: "rotate-box" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rotate-show" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "rotate-ball" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "color-panel" }
const _hoisted_18 = { class: "img-content" }
const _hoisted_19 = {
  key: 0,
  class: "loading-box"
}
const _hoisted_20 = { class: "top" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "22",
  src: _imports_0
}, null, -1))
const _hoisted_22 = { class: "title" }
const _hoisted_23 = { class: "progress" }
const _hoisted_24 = { class: "bottom" }
const _hoisted_25 = {
  key: 1,
  class: "upload-box"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "svg",
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22"
}, [
  /*#__PURE__*/_createElementVNode("defs"),
  /*#__PURE__*/_createElementVNode("rect", {
    class: "a",
    width: "22",
    height: "22"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "b",
    d: "M5,10A1,1,0,0,1,4,9V6H1A1,1,0,0,1,0,5H0A1,1,0,0,1,1,4H4V1A1,1,0,0,1,5,0H5A1,1,0,0,1,6,1V4H9a1,1,0,0,1,1,1h0A1,1,0,0,1,9,6H6V9a1,1,0,0,1-1,1Z",
    transform: "translate(6 6)"
  })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传图片", -1))
const _hoisted_28 = ["accept"]
const _hoisted_29 = { class: "image-box" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "upload-div" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "替换图片", -1))
const _hoisted_33 = ["accept"]
const _hoisted_34 = {
  key: 0,
  class: "recently brand-color-box"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand-color" }, "品牌颜色", -1))
const _hoisted_36 = { class: "brand-color-box-scoll" }
const _hoisted_37 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sketch = _resolveComponent("Sketch")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "popover-box",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showAngleBox = false))
    }, [
      (!_ctx.hiddenRecentColor)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.recentColorList.length > 0 && _ctx.activeTab === _ctx.ColorType.Color)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentColorList, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        onClick: ($event: any) => (_ctx.updateColor(item)),
                        key: index
                      }, [
                        _createElementVNode("div", {
                          style: _normalizeStyle({ background: item })
                        }, null, 4)
                      ], 8, _hoisted_4))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.recentGradientList.length > 0 && _ctx.activeTab === _ctx.ColorType.GradientColor)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentGradientList, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        onClick: ($event: any) => (_ctx.recentGradientClick(item)),
                        key: index
                      }, [
                        _createElementVNode("div", {
                          style: _normalizeStyle({ backgroundImage: `linear-gradient(${item.gradient})` })
                        }, null, 4)
                      ], 8, _hoisted_7))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.colorModeList.length > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "color-mode",
            style: _normalizeStyle({ marginTop: _ctx.hiddenRecentColor ? '0px' : '15px' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorModeList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["common", _ctx.activeTab === item.tab ? 'active' : '']),
                key: index,
                onClick: ($event: any) => (_ctx.tabClick(item))
              }, [
                _createElementVNode("span", null, _toDisplayString(item.text), 1)
              ], 10, _hoisted_8))
            }), 128))
          ], 4))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Sketch, {
            disableAlpha: _ctx.hiddenAlpha,
            onStrawClick: _ctx.strawColor,
            modelValue: _ctx.myColors,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateColor($event)))
          }, null, 8, ["disableAlpha", "onStrawClick", "modelValue"])
        ])
      ], 512), [
        [_vShow, _ctx.activeTab === _ctx.ColorType.Color]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "gradient",
            ref: "gradientDom",
            id: "gradient",
            style: _normalizeStyle({ backgroundImage: _ctx.gradientColorStr })
          }, [
            _createElementVNode("div", {
              class: "gradient-track",
              ref: "gradientTrackDom",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleTrackClick && _ctx.handleTrackClick(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myGradientColors.gradient, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["gradient-item", { active: _ctx.currentGradientIndex === index }]),
                  onClick: _withModifiers(($event: any) => {
                  _ctx.showAngleBox = false;
                  _ctx.currentGradientIndex = index;
                }, ["stop"]),
                  onMousedown: ($event: any) => {
                  _ctx.showAngleBox = false;
                  _ctx.handleGradientItemMouseDown($event, index, item);
                },
                  key: index,
                  style: _normalizeStyle({ left: `calc(${item.position} - 10px)` })
                }, [
                  _createElementVNode("div", {
                    class: "color",
                    style: _normalizeStyle({ backgroundColor: item.color })
                  }, null, 4)
                ], 46, _hoisted_11))
              }), 128))
            ], 512)
          ], 4),
          _createElementVNode("div", {
            class: "angle-box",
            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", {
              class: "gradient-angle degree-text num-text",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showAngleBox = !_ctx.showAngleBox), ["stop"]))
            }, [
              _createElementVNode("input", {
                class: "angle-input",
                max: 360,
                min: 0,
                value: _ctx.angle,
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateColor($event?.target?.value, 'direction')))
              }, null, 40, _hoisted_12),
              _hoisted_13
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: "rotate-area",
                style: _normalizeStyle({ transform: `rotate(${_ctx.angle}deg)` }),
                onMousedown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleRotateMouseDown($event))),
                ref: "rotateAreaDom"
              }, _hoisted_16, 36)
            ], 512), [
              [_vShow, _ctx.showAngleBox]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_Sketch, {
            disableAlpha: _ctx.hiddenAlpha,
            onStrawClick: _ctx.strawColor,
            modelValue: _ctx.currentGradientColor,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateColor($event)))
          }, null, 8, ["disableAlpha", "onStrawClick", "modelValue"])
        ])
      ], 512), [
        [_vShow, _ctx.activeTab === _ctx.ColorType.GradientColor]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_18, [
          (!_ctx.imageUrl)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.isUpload)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.fileName), 1),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.progressText) + "%", 1)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_el_progress, {
                          "stroke-width": 8,
                          "show-text": false,
                          percentage: _ctx.progressText
                        }, null, 8, ["percentage"])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _hoisted_27,
                      _createElementVNode("input", {
                        accept: _ctx.uploadInfo.accept,
                        type: "file",
                        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args)))
                      }, null, 40, _hoisted_28)
                    ]))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("img", {
                    src: 'https://resources.laihua.com/' + _ctx.imageUrl
                  }, null, 8, _hoisted_30)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("input", {
                    accept: _ctx.uploadInfo.accept,
                    type: "file",
                    onChange: _cache[8] || (_cache[8] = ($event: any) => {_ctx.imageUrl =''; _ctx.uploadImage($event)})
                  }, null, 40, _hoisted_33)
                ])
              ], 64))
        ])
      ], 512), [
        [_vShow, _ctx.activeTab === _ctx.ColorType.Image]
      ])
    ]),
    (_ctx.brandColors.length > 0 && _ctx.activeTab === _ctx.ColorType.Color)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandColors, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  onClick: ($event: any) => (_ctx.updateColor(item.color)),
                  key: index
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({ background: item.color })
                  }, null, 4)
                ], 8, _hoisted_37))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}